import { createAction, handleActions } from "redux-actions";
import {
  _getActiveServiceTypesList,
  _getServiceNamesList,
  _getActiveShampooList,
  _getActiveCologneList,
  _createNewAppointment,
  _getActiveServices,
  _getServiceAmount,
  _getAvailableTimeSlots,
  _getAvailableTimeSlotsManual,
  _getCustomerListByNameSearch,
  _getCustomerAddressById,
} from "~shared/httpService/apis";
import ActionTypes from "~shared/constants/actionTypes";
import { _getServiceTypeByPagination } from "../../../shared/httpService/apis";

const initialState = {
  service_types: { loading: false, response: [], hasError: false, error: {} },
  service_names: { loading: false, response: [], hasError: false, error: {} },
  shampoo_list: { loading: false, response: [], hasError: false, error: {} },
  cologne_list: { loading: false, response: [], hasError: false, error: {} },
  new_appointment: { loading: false, response: [], hasError: false, error: {} },
  active_services: { loading: false, response: [], hasError: false, error: {} },
  service_amount: { loading: false, response: [], hasError: false, error: {} },
  time_slots: { loading: false, response: [], hasError: false, error: {} },
  time_slots_manual: { loading: false, response: [], hasError: false, error: {} },

  search_customer_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  customer_address_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
};

const getActiveServiceTypesListStart = createAction(
  ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST
);
const getActiveServiceTypesListSuccess = createAction(
  ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST_SUCCESS,
  (response) => response
);
const getActiveServiceTypesListError = createAction(
  ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST_ERROR,
  (error) => error
);

export const getActiveServiceTypesList = (page, pageSize,search) => (dispatch) => {
  dispatch(getActiveServiceTypesListStart());
  return _getServiceTypeByPagination(page, pageSize,search)
    .then((response) => {
      dispatch(getActiveServiceTypesListSuccess(response));
    })
    .catch((error) => {
      dispatch(getActiveServiceTypesListError(error));
    });
};

const getServiceNamesListStart = createAction(
  ActionTypes.GET_SERVICE_NAME_LIST
);
const getServiceNamesListSuccess = createAction(
  ActionTypes.GET_SERVICE_NAME_LIST_SUCCESS,
  (response) => response
);
const getServiceNamesListError = createAction(
  ActionTypes.GET_SERVICE_NAME_LIST_ERROR,
  (error) => error
);

export const getServiceNamesList = (id) => (dispatch) => {
  dispatch(getServiceNamesListStart());
  return _getServiceNamesList(id)
    .then((response) => {
      dispatch(getServiceNamesListSuccess(response));
    })
    .catch((error) => {
      dispatch(getServiceNamesListError(error));
    });
};

const getActiveShampooListStart = createAction(
  ActionTypes.GET_ACTIVE_SHAMPOO_LIST
);
const getActiveShampooListSuccess = createAction(
  ActionTypes.GET_ACTIVE_SHAMPOO_LIST_SUCCESS,
  (response) => response
);
const getActiveShampooListError = createAction(
  ActionTypes.GET_ACTIVE_SHAMPOO_LIST_ERROR,
  (error) => error
);

export const getActiveShampooList = () => (dispatch) => {
  dispatch(getActiveShampooListStart());
  return _getActiveShampooList()
    .then((response) => {
      dispatch(getActiveShampooListSuccess(response));
    })
    .catch((error) => {
      dispatch(getActiveShampooListError(error));
    });
};

const getActiveCologneListStart = createAction(
  ActionTypes.GET_ACTIVE_COLOGNE_LIST
);
const getActiveCologneListSuccess = createAction(
  ActionTypes.GET_ACTIVE_COLOGNE_LIST_SUCCESS,
  (response) => response
);
const getActiveCologneListError = createAction(
  ActionTypes.GET_ACTIVE_COLOGNE_LIST_ERROR,
  (error) => error
);

const getCustomerListBySearch = createAction(
  ActionTypes.GET_CUSTOMER_LIST_BY_SEARCH
);
const getCustomerListBySearchSuccess = createAction(
  ActionTypes.GET_CUSTOMER_LIST_BY_SEARCH_SUCCESS,
  (response) => response
);
const getCustomerListBySearchError = createAction(
  ActionTypes.GET_CUSTOMER_LIST_BY_SEARCH_ERROR,
  (error) => error
);
export const getCustomerListBySearching =
  (schemaName, search, page) => (dispatch) => {
    dispatch(getCustomerListBySearch());
    return _getCustomerListByNameSearch(schemaName, search, page)
      .then((response) => {
        dispatch(getCustomerListBySearchSuccess(response));
      })
      .catch((error) => dispatch(getCustomerListBySearchError(error)));
  };

const getCustomerAddressById = createAction(
  ActionTypes.GET_CUSTOMER_ADDRESS_LIST
);
const getCustomerAddressByIdSuccess = createAction(
  ActionTypes.GET_CUSTOMER_ADDRESS_LIST_SUCCESS,
  (response) => response
);
const getCustomerAddressByIdError = createAction(
  ActionTypes.GET_CUSTOMER_ADDRESS_LIST_ERROR,
  (error) => error
);
export const getCustomerAddress =
  (schemaName, customerId, searchkey) => (dispatch) => {
    dispatch(getCustomerAddressById());
    return _getCustomerAddressById(schemaName, customerId, searchkey)
      .then((response) => {
        dispatch(getCustomerAddressByIdSuccess(response));
      })
      .catch((error) => dispatch(getCustomerAddressByIdError(error)));
  };
export const getActiveCologneList = () => (dispatch) => {
  dispatch(getActiveCologneListStart());
  return _getActiveCologneList()
    .then((response) => {
      dispatch(getActiveCologneListSuccess(response));
    })
    .catch((error) => {
      dispatch(getActiveCologneListError(error));
    });
};

export const createNewAppointmentStart = createAction(
  ActionTypes.CREATE_NEW_APPOINTMENT
);
export const createNewAppointmentSuccess = createAction(
  ActionTypes.CREATE_NEW_APPOINTMENT_SUCCESS,
  (response) => response
);
export const createNewAppointmentError = createAction(
  ActionTypes.CREATE_NEW_APPOINTMENT_ERROR,
  (error) => error
);

export const createNewAppointment = (data) => (dispatch) => {
  dispatch(createNewAppointmentStart());
  return _createNewAppointment(data)
    .then((response) => {
      dispatch(createNewAppointmentSuccess(response));
    })
    .catch((error) => {
      dispatch(createNewAppointmentError(error));
    });
};

const getActiveServicesStart = createAction(
  ActionTypes.GET_ACTIVE_SERVICES_LIST
);
const getActiveServicesSuccess = createAction(
  ActionTypes.GET_ACTIVE_SERVICES_LIST_SUCCESS,
  (response) => response
);
const getActiveServicesError = createAction(
  ActionTypes.GET_ACTIVE_SERVICES_LIST_ERROR,
  (error) => error
);

export const getActiveServices = () => (dispatch) => {
  dispatch(getActiveServicesStart());
  return _getActiveServices()
    .then((response) => {
      dispatch(getActiveServicesSuccess(response));
    })
    .catch((error) => {
      dispatch(getActiveServicesError(error));
    });
};

const getServiceAmountStart = createAction(ActionTypes.GET_SERVICE_AMOUNT);
const getServiceAmountSuccess = createAction(
  ActionTypes.GET_SERVICE_AMOUNT_SUCCESS,
  (response) => response
);
const getServiceAmountError = createAction(
  ActionTypes.GET_SERVICE_AMOUNT_ERROR,
  (error) => error
);

export const getServiceAmount = (data) => (dispatch) => {
  dispatch(getServiceAmountStart());
  return _getServiceAmount(data)
    .then((response) => {
      dispatch(getServiceAmountSuccess(response));
    })
    .catch((error) => {
      dispatch(getServiceAmountError(error));
    });
};

/* eslint-disable */
const getAvailableTimeSlotsStart = createAction(
  ActionTypes.GET_AVAILABLE_TIME_SLOTS
);
const getAvailableTimeSlotsSuccess = createAction(
  ActionTypes.GET_AVAILABLE_TIME_SLOTS_SUCCESS,
  (response) => response
);
const getAvailableTimeSlotsError = createAction(
  ActionTypes.GET_AVAILABLE_TIME_SLOTS_ERROR,
  (error) => error
);

export const getAvailableTimeSlots =
  (serviceId, venueId, attendantId, duration, date, tz) => (dispatch) => {
    dispatch(getAvailableTimeSlotsStart());
    return _getAvailableTimeSlots(
      serviceId,
      venueId,
      attendantId,
      duration,
      date,
      tz
    )
      .then((response) => {
        dispatch(getAvailableTimeSlotsSuccess(response));
      })
      .catch((error) => {
        dispatch(getAvailableTimeSlotsError(error));
        // const data = [
        //   {
        //     slotStartTime: "2021-03-04T06:10:48.056Z",
        //     slotEndTime: "2021-03-04T08:10:48.056Z",
        //   },
        //   {
        //     slotStartTime: "2021-03-04T06:10:48.056Z",
        //     slotEndTime: "2021-03-04T06:10:48.056Z",
        //   },
        //   {
        //     slotStartTime: "2021-03-04T06:10:48.056Z",
        //     slotEndTime: "2021-03-04T06:10:48.056Z",
        //   },
        //   {
        //     slotStartTime: "2021-03-04T06:10:48.056Z",
        //     slotEndTime: "2021-03-04T06:10:48.056Z",
        //   },
        // ];
        // dispatch(getAvailableTimeSlotsSuccess(data));
      });
  };


  const getAvailableTimeSlotsManualStart = createAction(
    ActionTypes.GET_AVAILABLE_TIME_SLOTS_MANUAL
  );
  const getAvailableTimeSlotsManualSuccess = createAction(
    ActionTypes.GET_AVAILABLE_TIME_SLOTS_MANUAL_SUCCESS,
    (response) => response
  );
  const getAvailableTimeSlotsManualError = createAction(
    ActionTypes.GET_AVAILABLE_TIME_SLOTS_MANUAL_ERROR,
    (error) => error
  );

  //function for manual slots
  export const getAvailableTimeSlotsManual =
  (serviceId, venueId, attendantId, duration, date, tz) => (dispatch) => {
    dispatch(getAvailableTimeSlotsManualStart());
    return _getAvailableTimeSlotsManual(
      serviceId,
      venueId,
      attendantId,
      duration,
      date,
      tz
    )
      .then((response) => {
        console.log(response,"response")
        dispatch(getAvailableTimeSlotsManualSuccess(response));
      })
      .catch((error) => {
        dispatch(getAvailableTimeSlotsManualError(error));
        // const data = [
        //   {
        //     slotStartTime: "2021-03-04T06:10:48.056Z",
        //     slotEndTime: "2021-03-04T08:10:48.056Z",
        //   },
        //   {
        //     slotStartTime: "2021-03-04T06:10:48.056Z",
        //     slotEndTime: "2021-03-04T06:10:48.056Z",
        //   },
        //   {
        //     slotStartTime: "2021-03-04T06:10:48.056Z",
        //     slotEndTime: "2021-03-04T06:10:48.056Z",
        //   },
        //   {
        //     slotStartTime: "2021-03-04T06:10:48.056Z",
        //     slotEndTime: "2021-03-04T06:10:48.056Z",
        //   },
        // ];
        // dispatch(getAvailableTimeSlotsSuccess(data));
      });
  };

const reducer = handleActions(
  {
    //ACTIVE_SERVICE_TYPES_LIST
    [ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST]: (state) => ({
      ...state,
      service_types: {
        ...state.service_types,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST_SUCCESS]: (state, action) => ({
      ...state,
      service_types: {
        ...state.service_types,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST_ERROR]: (state, action) => ({
      ...state,
      service_types: {
        ...state.service_types,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //SERVICE_NAMES_LIST
    [ActionTypes.GET_SERVICE_NAME_LIST]: (state) => ({
      ...state,
      service_names: {
        ...state.service_names,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_SERVICE_NAME_LIST_SUCCESS]: (state, action) => ({
      ...state,
      service_names: {
        ...state.service_names,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_SERVICE_NAME_LIST_ERROR]: (state, action) => ({
      ...state,
      service_names: {
        ...state.service_names,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    //SHAMPOO_LIST
    [ActionTypes.GET_ACTIVE_SHAMPOO_LIST]: (state) => ({
      ...state,
      shampoo_list: {
        ...state.shampoo_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_SHAMPOO_LIST_SUCCESS]: (state, action) => ({
      ...state,
      shampoo_list: {
        ...state.shampoo_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_SHAMPOO_LIST_ERROR]: (state, action) => ({
      ...state,
      shampoo_list: {
        ...state.shampoo_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    //COLOGNE_LIST
    [ActionTypes.GET_ACTIVE_COLOGNE_LIST]: (state) => ({
      ...state,
      cologne_list: {
        ...state.cologne_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_COLOGNE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      cologne_list: {
        ...state.cologne_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_COLOGNE_LIST_ERROR]: (state, action) => ({
      ...state,
      cologne_list: {
        ...state.cologne_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    //CREATE_APPOINTMENT
    [ActionTypes.CREATE_NEW_APPOINTMENT]: (state) => ({
      ...state,
      new_appointment: {
        ...state.new_appointment,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.CREATE_NEW_APPOINTMENT_SUCCESS]: (state, action) => ({
      ...state,
      new_appointment: {
        ...state.new_appointment,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.CREATE_NEW_APPOINTMENT_ERROR]: (state, action) => ({
      ...state,
      new_appointment: {
        ...state.new_appointment,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //ACTIVE_SERVICES
    [ActionTypes.GET_ACTIVE_SERVICES_LIST]: (state) => ({
      ...state,
      active_services: {
        ...state.active_services,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_SERVICES_LIST_SUCCESS]: (state, action) => ({
      ...state,
      active_services: {
        ...state.active_services,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_SERVICES_LIST_ERROR]: (state, action) => ({
      ...state,
      active_services: {
        ...state.active_services,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //SERVICE_AMOUNT
    [ActionTypes.GET_SERVICE_AMOUNT]: (state) => ({
      ...state,
      service_amount: {
        ...state.service_amount,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_SERVICE_AMOUNT_SUCCESS]: (state, action) => ({
      ...state,
      service_amount: {
        ...state.service_amount,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_SERVICE_AMOUNT_ERROR]: (state, action) => ({
      ...state,
      service_amount: {
        ...state.service_amount,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //AVAILABLE_TIME_SLOTS
    [ActionTypes.GET_AVAILABLE_TIME_SLOTS]: (state) => ({
      ...state,
      time_slots: {
        ...state.time_slots,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_AVAILABLE_TIME_SLOTS_SUCCESS]: (state, action) => ({
      ...state,
      time_slots: {
        ...state.time_slots,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_AVAILABLE_TIME_SLOTS_ERROR]: (state, action) => ({
      ...state,
      time_slots: {
        ...state.time_slots,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),


    //MANUAL SLOTS


    [ActionTypes.GET_AVAILABLE_TIME_SLOTS_MANUAL]: (state) => ({
      ...state,
      time_slots_manual: {
        ...state.time_slots,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_AVAILABLE_TIME_SLOTS_MANUAL_SUCCESS]: (state, action) => ({
      ...state,
      time_slots_manual: {
        ...state.time_slots,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_AVAILABLE_TIME_SLOTS_MANUAL_ERROR]: (state, action) => ({
      ...state,
      time_slots_manual: {
        ...state.time_slots,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    // CUSTOMER LIST BY SEARCHING
    [ActionTypes.GET_CUSTOMER_LIST_BY_SEARCH]: (state) => ({
      ...state,
      search_customer_list: {
        ...state.search_customer_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_LIST_BY_SEARCH_SUCCESS]: (state, action) => ({
      ...state,
      search_customer_list: {
        ...state.search_customer_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_LIST_BY_SEARCH_ERROR]: (state, action) => ({
      ...state,
      search_customer_list: {
        ...state.search_customer_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    // CUSTOMER ADDRESS SEARCH BY ID
    [ActionTypes.GET_CUSTOMER_ADDRESS_LIST]: (state) => ({
      ...state,
      customer_address_list: {
        ...state.customer_address_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_ADDRESS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      customer_address_list: {
        ...state.customer_address_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_ADDRESS_LIST_ERROR]: (state, action) => ({
      ...state,
      customer_address_list: {
        ...state.customer_address_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
  },
  initialState
);

export default reducer;
